import { Button, DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceSourcePcMiler extends Layout {
    buttonUpdateCityFiles: Button;
    labelUpdatePCMilerCityFiles: Label;
    panelUpdateCityFiles: Panel;
    sourceDistanceSource: DataSource;
    sourceDistanceVersion: DataSource;
    switchAdditionalUpdateCitySettings: Switch;
    switchExecuteUpdates: Switch;
    switchOrderHistoryRecords: Switch;
    switchPrintEditList: Switch;
    switchStreetLevel: Switch;
    switchTollsCapable: Switch;
    switchUpdateLocation: Switch;
    switchUpdateStops: Switch;
    tableDistanceVersions: Table;
    textboxPcMilerUpdateVersion: Textbox;
    textboxPcMilerVendorOptions: Textbox;
    textboxUpdateType: Textbox;
    textboxWebserviceApiKey: Textbox;
    textboxWebserviceOptionLevel: Textbox;
    textboxWebserviceUrl: Textbox;
}
